declare module '@mui/system/createTheme/shape' {
	interface Shape {
		borderRadiusXs: number | string;
		borderRadiusSm: number | string;
		borderRadiusMd: number | string;
		borderRadiusLg: number | string;
	}
}

const shape = {
	borderRadius: 5,
	borderRadiusXs: 2,
	borderRadiusSm: 12,
	borderRadiusMd: 16,
	borderRadiusLg: 25,
};

export default shape;
